module.exports = __webpack_public_path__ + "assets/images/skai-new.ab4bbd702f714b06fc076ad67f2844c2.png";